// Утилита для проверки админа через backend API
// Безопасная система с зашифрованными данными на сервере

// Функция для проверки, является ли пользователь админом
export async function isUserAdmin(userId: number, email: string): Promise<boolean> {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/check_admin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        user_id: userId,
        email: email
      })
    });

    if (response.ok) {
      const data = await response.json();
      return data.is_admin || false;
    }
    
    return false;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

// Функция для добавления нового админа (используется для генерации зашифрованных данных)
export function generateAdminCredentials(userId: number, email: string) {
  console.log('Admin credentials for encryption:');
  console.log('user_id:', userId);
  console.log('email:', email);
  console.log('Note: Use backend script to encrypt these credentials');
} 